/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */var isNodeOrChild=function isNodeOrChild(parent,child){if(!child){return false;}else if(parent===child){return true;}else{return isNodeOrChild(parent,child.parentElement);}};export{isNodeOrChild};